// extracted by css-extract-rspack-plugin
export default {"skeletonText":"ActivityLoading-module__skeletonText__GM4hC"};